import { useUnit } from 'effector-react'
import React from 'react'

import { getMessageElementById } from '@/widgets/chat/view/lib'

import * as chatModel from '../model'
import { useMessageScroller } from '../view/context'

export function useScrollToMessage(): (messageId: string, behavior?: 'smooth' | 'auto' | 'instant') => void {
    const scroller = useMessageScroller()
    const handleMessageHighlight = useUnit(chatModel.messageHighlight)

    const handler = React.useCallback(
        (messageId: string, behavior: 'smooth' | 'auto' | 'instant' = 'smooth') => {
            // fast path: if message is already rendered, scroll to it
            const messageElement = getMessageElementById(messageId)
            if (messageElement) {
                messageElement.scrollIntoView({
                    behavior: behavior === 'instant' ? undefined : behavior,
                    block: 'center',
                })
                handleMessageHighlight({ messageId })
                return
            }

            const virtuoso = scroller?.virtuoso
            if (!virtuoso) {
                return
            }

            const item = scroller.items?.find(
                (item) =>
                    (item.data.type === 'message_group' && item.data.payload.message.id === messageId) ||
                    (item.data.type === 'message' && item.data.payload.id === messageId)
            )
            if (!item) {
                return
            }

            virtuoso.scrollToIndex({
                index: item.index,
                behavior: behavior === 'instant' ? undefined : behavior,
                align: 'center',
            })

            handleMessageHighlight({ messageId })
        },
        [scroller?.virtuoso, scroller.items, handleMessageHighlight]
    )

    return handler
}
